module.exports = __webpack_public_path__ + "img/logo_pedf.f4b5dc62.png";